import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const SellerAccount = createAsyncThunk(
  "sellerAccount/SellerAccount",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(endPoint.SellerAccountApi, {
        businessName: data?.name,
        email: data?.email,
        phone: data?.phone,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const SellerAccountSlice = createSlice({
  name: "SellerAccountData",
  initialState: {
    SellerAccountData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SellerAccount.fulfilled, (state, action) => {
        state.SellerAccountData = action.payload;
      })
      .addCase(SellerAccount.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default SellerAccountSlice.reducer;
